export const getDefaultComparer = (
  a,
  b,
  field: string,
  desc: boolean = false
) => {
  if ((b[field] ?? '') > (a[field] ?? '')) return desc ? 1 : -1;
  if ((b[field] ?? '') < (a[field] ?? '')) return desc ? -1 : 1;
  return 0;
};
